export const norwegianCountryCodeString = '(\\+|00)47';
export const norwegianCountryCode = new RegExp(`^${norwegianCountryCodeString}`);
